import { useRef, useState, useCallback } from 'react';
import FullCalendar from '@fullcalendar/react';
import {
    CalendarView,
    CalendarViewType,
} from '../types/calendar/calendarTypes';

interface UseCalendarProps {
    initialView?: CalendarViewType;
}

const useCalendar = ({
    initialView = CalendarView.MONTH,
}: UseCalendarProps = {}) => {
    const calendarRef = useRef<FullCalendar>(null);
    const [activeView, setActiveView] = useState<CalendarViewType>(initialView);
    const [idHoveredEvent, setIdHoveredEvent] = useState<string | null>(null);

    const getApi = () => calendarRef.current?.getApi();

    const changeView = useCallback((view: CalendarViewType) => {
        getApi()?.changeView(view);
        setActiveView(view);
    }, []);

    const goToDate = useCallback((date: string | Date) => {
        calendarRef.current?.getApi().gotoDate(date);
    }, []);

    const prev = useCallback(() => getApi()?.prev(), []);
    const next = useCallback(() => getApi()?.next(), []);
    const today = useCallback(() => getApi()?.today(), []);

    const hoverEvent = useCallback((eventId: string) => {
        setIdHoveredEvent(eventId);
    }, []);

    const unhoverEvent = useCallback(() => {
        setIdHoveredEvent(null);
    }, []);

    return {
        calendarRef,
        activeView,
        changeView,
        prev,
        next,
        today,
        goToDate,
        idHoveredEvent,
        hoverEvent,
        unhoverEvent,
    };
};

export default useCalendar;
